// The estimated size of a card. Used for virtualization.
export const CARD_SIZE_ESTIMATE = 125
// Vertical gap between cards
export const CARD_MARGIN_BOTTOM = 8
// Padding between column and cards
export const COLUMN_PADDING = 4
